webpackJsonp(["cover-selector.module"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/uniqueId.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/toString.js");

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/compare-pane.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global jQuery */


var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-compare-pane]";
var PLUGIN_NAME = "comparePane";
var log = (0, _debug2.default)(PLUGIN_NAME);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

// https://github.com/mattdesl/eases/blob/master/sine-in-out.js
function sineInOut(t) {
	return -0.5 * (Math.cos(Math.PI * t) - 1);
}

// https://vanillajstoolkit.com/helpers/debounce/
function debounce(fn) {
	// Setup a timer
	var timeout;

	// Return a function to run debounced
	return function () {

		// Setup the arguments
		var context = this;
		var args = arguments;

		// If there's a timer, cancel it
		if (timeout) {
			window.cancelAnimationFrame(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = window.requestAnimationFrame(function () {
			fn.apply(context, args);
		});
	};
};

var ComparePane = function () {
	function ComparePane(element, options) {
		_classCallCheck(this, ComparePane);

		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.scrollLeft = 0;
		this.scrollWidth = 0;
		this.clientWidth = 0;
		this.stepWidth = 0;

		this.pane = this.element.querySelector(this.options.paneSelector);

		this.stepWidthElement = this.element.querySelector(this.options.stepWidthElementSelector);

		this.buttonLeft = this.element.querySelector(this.options.buttonLeftSelector);

		this.buttonRight = this.element.querySelector(this.options.buttonRightSelector);

		this.debouncedUpdate = debounce(this.update);

		this.init();
		this.watch();

		log("ready", this, this.element);
	}

	_createClass(ComparePane, [{
		key: "init",
		value: function init() {
			this.update();
		}
	}, {
		key: "watch",
		value: function watch() {
			log("watching");

			window.addEventListener('resize', this.debouncedUpdate.bind(this));
			this.pane.addEventListener('scroll', this.debouncedUpdate.bind(this));
			this.buttonLeft.addEventListener('click', this.scrollPaneLeft.bind(this));
			this.buttonRight.addEventListener('click', this.scrollPaneRight.bind(this));
		}
	}, {
		key: "measure",
		value: function measure() {
			this.scrollLeft = this.pane.scrollLeft || 0;
			this.scrollWidth = this.pane.scrollWidth;
			this.clientWidth = this.pane.clientWidth;
			this.stepWidth = this.stepWidthElement.clientWidth;
		}
	}, {
		key: "update",
		value: function update() {
			this.measure();
			this.updateDisabled(this.buttonLeft, this.isLeftMax.bind(this));
			this.updateDisabled(this.buttonRight, this.isRightMax.bind(this));
			this.updateFocusable(this.pane, this.isScrollable.bind(this));
		}
	}, {
		key: "updateDisabled",
		value: function updateDisabled(button, condition) {
			button.disabled = !!condition();
		}
	}, {
		key: "updateFocusable",
		value: function updateFocusable(pane, condition) {
			pane.tabindex = !!condition() ? '0' : '-1';
		}
	}, {
		key: "isLeftMax",
		value: function isLeftMax() {
			return this.scrollLeft < this.options.scrollEdgeThreshold;
		}
	}, {
		key: "isRightMax",
		value: function isRightMax() {
			return this.scrollWidth - this.clientWidth - this.scrollLeft < this.options.scrollEdgeThreshold;
		}
	}, {
		key: "isScrollable",
		value: function isScrollable() {
			return !this.isLeftMax() || !this.isRightMax();
		}
	}, {
		key: "isFocusable",
		value: function isFocusable() {
			return this.isScrollable() ? '0' : '-1';
		}
	}, {
		key: "smoothScroll",
		value: function smoothScroll(param, timestamp) {
			var _param$startTime = param.startTime,
			    startTime = _param$startTime === undefined ? timestamp : _param$startTime,
			    startPos = param.startPos,
			    direction = param.direction,
			    duration = param.duration;


			var scrollStep = this.stepWidth;

			var timeElapsed = timestamp - startTime;
			var easeElapsed = timeElapsed / duration;
			var targetScrollDist = scrollStep * direction;

			this.pane.scrollLeft = startPos + targetScrollDist * sineInOut(easeElapsed);

			if (timeElapsed < duration) {
				window.requestAnimationFrame(this.smoothScroll.bind(this, {
					startPos: startPos,
					direction: direction,
					duration: duration,
					startTime: startTime
				}));
			}
		}
	}, {
		key: "scrollPaneLeft",
		value: function scrollPaneLeft() {
			var startPos = this.pane.scrollLeft;
			var scroller = this.smoothScroll.bind(this, {
				startPos: startPos,
				direction: -1,
				duration: this.options.scrollDuration
			});
			window.requestAnimationFrame(scroller);
		}
	}, {
		key: "scrollPaneRight",
		value: function scrollPaneRight() {
			var startPos = this.pane.scrollLeft;
			var scroller = this.smoothScroll.bind(this, {
				startPos: startPos,
				direction: 1,
				duration: this.options.scrollDuration
			});
			window.requestAnimationFrame(scroller);
		}
	}]);

	return ComparePane;
}();

ComparePane.DEFAULTS = {
	scrollEdgeThreshold: 5,
	scrollDuration: 500
};

(0, _lib2.default)(PLUGIN_NAME, ComparePane);

$(document).ready(function () {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/compare-summary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global jQuery */


var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-compare-summary]";
var PLUGIN_NAME = "compareSummary";

var log = (0, _debug2.default)(PLUGIN_NAME);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var CompareSummary = function () {
	function CompareSummary(element, options) {
		_classCallCheck(this, CompareSummary);

		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		// Elements
		// - frequency select
		// - excess radios
		// - rate display

		this.frequencyInput = this.element.querySelector(this.options.frequencyInputSelector);

		this.excessInput = this.element.querySelector(this.options.excessInputSelector);
		this.excessInputsArray = [].concat(_toConsumableArray(this.element.querySelectorAll(this.options.excessInputSelector)));

		// Specifically has excess options
		this.hasMultipleProducts = !!this.options.excessInputSelector;

		this.rateDisplay = this.element.querySelector(this.options.rateDisplaySelector);

		this.futureRateDisplay = this.element.querySelector(this.options.futureRateDisplaySelector);

		// Rate may not be displayed
		// Only run associated update method if it is
		this.updateRateDisplay = this.rateDisplay ? this.updateRateDisplayMethod : function () {};

		this.updateFutureRateDisplay = this.futureRateDisplay ? this.updateFutureRateDisplayMethod : function () {};

		this.frequencies = this.frequencyInput ? [].concat(_toConsumableArray(this.frequencyInput.options)).map(function (option) {
			return option.value;
		}) : [];

		this.syncElements = {
			"data-compare-summary--sync-frequency": this.frequencyInput
			//, 'data-compare-summary--sync-excess': this.excessInput.form.elements[this.excessInput.name]
		};

		// Extract rates data from inputs for this product
		this.rates = this.hasMultipleProducts ? this.getRatesFromInputs() : this.getRatesFromData();

		this.futureRates = this.hasMultipleProducts ? this.getFutureRatesFromInputs() : this.getFutureRatesFromData();

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.watch();

		log("ready", this, this.element);
	}

	_createClass(CompareSummary, [{
		key: "watch",
		value: function watch() {
			log("watching");

			this.element.addEventListener("change", this.onChange.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });
		}
	}, {
		key: "getRatesFromInputs",
		value: function getRatesFromInputs() {
			return this.excessInputsArray.reduce(function (object, input) {
				return Object.assign(_defineProperty({}, input.id, getJSONValue(input.dataset["rates"])), object);
			}, {});
		}
	}, {
		key: "getFutureRatesFromInputs",
		value: function getFutureRatesFromInputs() {
			return this.excessInputsArray.reduce(function (object, input) {
				return Object.assign(_defineProperty({}, input.id, getJSONValue(input.dataset["futureRates"])), object);
			}, {});
		}
	}, {
		key: "getRatesFromData",
		value: function getRatesFromData() {
			return {
				'rates': getJSONValue(this.options.syncRates)
			};
		}
	}, {
		key: "getFutureRatesFromData",
		value: function getFutureRatesFromData() {
			return {
				'rates': getJSONValue(this.options.syncFutureRates)
			};
		}
	}, {
		key: "onChange",
		value: function onChange() {
			// update form element data attr
			for (var attr in this.syncElements) {
				var value = this.syncElements[attr].value;
				this.element.setAttribute(attr, value);
			}

			// sync rates data attr - ref for cover selector component
			var chosenRates = this.rates[this.getProductId()];
			this.element.setAttribute("data-compare-summary--sync-rates", JSON.stringify(chosenRates));

			var chosenFutureRates = this.futureRates[this.getProductId()];
			this.element.setAttribute("data-compare-summary--sync-future-rates", JSON.stringify(chosenFutureRates));

			this.updateRateDisplay();
			this.updateFutureRateDisplay();

			// update other instances
			$(this.element).trigger("coverchange");
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && this.syncElements[mutation.attributeName];
			}.bind(this)).forEach(this.applyAttributeChanges.bind(this));
		}

		// Update value of corresponding form elements

	}, {
		key: "applyAttributeChanges",
		value: function applyAttributeChanges(mutation) {
			var attribute = mutation.attributeName;
			var newValue = this.element.getAttribute(attribute);
			var input = this.syncElements[attribute];
			input.value = newValue;
			this.updateRateDisplay();
			this.updateFutureRateDisplay();
		}
	}, {
		key: "updateRateDisplayMethod",
		value: function updateRateDisplayMethod() {
			var frequency = this.frequencyInput.value;
			var productId = this.getProductId();
			this.rateDisplay.textContent = this.getRate(productId, frequency).toFixed(2);
		}
	}, {
		key: "updateFutureRateDisplayMethod",
		value: function updateFutureRateDisplayMethod() {
			var frequency = this.frequencyInput.value;
			var productId = this.getProductId();
			this.futureRateDisplay.textContent = this.getFutureRate(productId, frequency).toFixed(2);
		}
	}, {
		key: "getRate",
		value: function getRate(productId, frequency) {
			var frequencyIndex = this.frequencies.findIndex(function (periodName) {
				return frequency === periodName;
			});

			return this.rates[productId][frequencyIndex];
		}
	}, {
		key: "getFutureRate",
		value: function getFutureRate(productId, frequency) {
			var frequencyIndex = this.frequencies.findIndex(function (periodName) {
				return frequency === periodName;
			});

			return this.futureRates[productId][frequencyIndex];
		}
	}, {
		key: "getProductId",
		value: function getProductId() {
			if (!this.hasMultipleProducts) {
				return 'rates';
			}
			var checkedExcessInput = this.excessInputsArray.find(function (input) {
				return input.checked;
			});

			return checkedExcessInput.id;
		}
	}]);

	return CompareSummary;
}();

CompareSummary.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, CompareSummary);

$(document).ready(function () {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/cover-selector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global jQuery */


var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-cover-selector]";
var PLUGIN_NAME = "coverSelector";

var log = (0, _debug2.default)(PLUGIN_NAME);

var CoverSelector = function () {
	function CoverSelector(element, options) {
		_classCallCheck(this, CoverSelector);

		log("element", element);
		log("options", options);

		this.options = options;
		this.form = element;

		this.inclusionsToggles = [].concat(_toConsumableArray(this.form.querySelectorAll(this.options.inclusionsToggleSelector)));
		this.exclusionsToggles = [].concat(_toConsumableArray(this.form.querySelectorAll(this.options.exclusionsToggleSelector)));
		this.prioritiesToggles = [].concat(_toConsumableArray(this.form.querySelectorAll(this.options.prioritiesToggleSelector)));
		this.errorMessage = this.form.querySelector(this.options.errorMessageSelector);
		this.submitLabel = this.form.querySelector(this.options.submitLabelSelector);

		// Elements that may have error messages to display
		this.componentErrorCollection = [].concat(_toConsumableArray(this.form.querySelectorAll(this.options.componentErrorSelector)));

		this.items = [].concat(_toConsumableArray(this.form.querySelectorAll(this.options.itemSelector)));
		this.choiceResultInput = this.form.querySelector(this.options.choiceResultInputSelector);

		// Status element may not exist
		// Only wire up methods if it does
		this.status = this.form.querySelector(this.options.statusSelector);
		this.updateStatus = this.status ? this.updateStatusMethod : function () {};
		this.updateStatusFrequency = this.status ? this.updateStatusFrequencyMethod : function () {};

		this.watch();
		log("ready", this, this.form);
	}

	_createClass(CoverSelector, [{
		key: "watch",
		value: function watch() {
			log("watching");

			this.form.addEventListener("change", this.onFormChange.bind(this));
			$(this.form).on("coverchange", this.onCoverChange.bind(this));
			$(this.form).on("toggleinclusions", this.toggleCollapsibles.bind(this, this.inclusionsToggles));
			$(this.form).on("toggleexclusions", this.toggleCollapsibles.bind(this, this.exclusionsToggles));
			$(this.form).on("togglepriorities", this.toggleCollapsibles.bind(this, this.prioritiesToggles));
			this.form.addEventListener("submit", this.onFormSubmit.bind(this));
		}
	}, {
		key: "onFormSubmit",
		value: function onFormSubmit(event) {
			var choiceValue = this.form.elements[this.options.choiceInputName].value;
			if (!choiceValue) {
				event.preventDefault();
				this.errorMessage.hidden = false;
			}
		}
	}, {
		key: "toggleCollapsibles",
		value: function toggleCollapsibles(toggles, event) {
			log("toggle", arguments);

			var sourceToggle = event.target;
			var targetToggles = toggles.filter(function (toggle) {
				return toggle !== sourceToggle;
			});

			targetToggles.forEach(function (toggle) {
				toggle.dataset.collapsibleOpen = sourceToggle.dataset.collapsibleOpen;
			});
		}
	}, {
		key: "onFormChange",
		value: function onFormChange(event) {
			log("onFormChange", event);

			this.updateProductDisplay();

			// Consider moving this to submit event?
			this.getSelectedProduct();
		}
	}, {
		key: "updateProductDisplay",
		value: function updateProductDisplay() {
			var chosenProductId = this.form.elements[this.options.choiceInputName].value;

			// abort if not chosen yet
			if (!chosenProductId) {
				return false;
			}

			var chosenItem = this.items.find(function (item) {
				return item.dataset["target-CoverSelector"] === "item:" + chosenProductId;
			});

			this.updateStatus(chosenItem);
			this.updateSubmitLabel(chosenItem);
		}
	}, {
		key: "updateStatusMethod",
		value: function updateStatusMethod(chosenItem) {
			// TODO: move these to config or data attr
			var rateToUpdate = {
				hospital: "quoteStatus-HospitalRates",
				extras: "quoteStatus-ExtrasRates"
			};
			var nameToUpdate = {
				hospital: "quoteStatus-HospitalName",
				extras: "quoteStatus-ExtrasName"
			};

			// rates (one of hospital/extras)
			var productRates = chosenItem.dataset["compareSummary-SyncRates"];
			this.status.dataset[rateToUpdate[this.options.choiceInputName]] = productRates;

			// name (one of hospital/extras)
			var productName = chosenItem.dataset["compareSummary-Name"];
			this.status.dataset[nameToUpdate[this.options.choiceInputName]] = productName;

			var noExtras = chosenItem.dataset["compareSummary-NoExtras"] === 'true';
			this.status.dataset["quoteStatus-NoExtras"] = noExtras;
		}
	}, {
		key: "updateStatusFrequencyMethod",
		value: function updateStatusFrequencyMethod(frequency) {
			this.status.dataset["quoteStatus-Frequency"] = frequency;
		}
	}, {
		key: "updateSubmitLabel",
		value: function updateSubmitLabel(chosenItem) {
			var buttonLabel = chosenItem.dataset['compareSummary-SubmitLabel'];
			if (buttonLabel && this.submitLabel) {
				this.submitLabel.textContent = buttonLabel;
			}
		}
	}, {
		key: "onCoverChange",
		value: function onCoverChange(event) {
			var _this = this;

			log("onCoverChange", event);

			var updatedItem = event.target;
			var itemsToUpdate = this.items.filter(function (item) {
				return item !== updatedItem;
			});

			// Sync values to other summary items
			itemsToUpdate.forEach(function (item) {
				_this.options.itemDataSync.forEach(function (attr) {
					item.dataset[attr] = updatedItem.dataset[attr];
				});
			});

			// updating status frequency even if no extras selected (hospital may have been)
			// will update using existing values
			var frequency = updatedItem.dataset["compareSummary-SyncFrequency"];
			this.updateStatusFrequency(frequency);
			this.updateProductDisplay();
		}
	}, {
		key: "getSelectedProduct",
		value: function getSelectedProduct() {
			//	Extras don't need this field as we can get value from choose input directly
			if (!this.options.choiceResultInputSelector || !this.choiceResultInput) {
				return false;
			}

			var productId = this.form.elements[this.options.choiceInputName].value;
			var excessOptions = this.form.elements["" + this.options.excessRadioNamePrefix + productId];

			log("selected product: ", excessOptions);
			this.choiceResultInput.value = excessOptions ? excessOptions.value : "";
		}
	}]);

	return CoverSelector;
}();

CoverSelector.DEFAULTS = {
	excessRadioNamePrefix: "cover_"
};

(0, _lib2.default)(PLUGIN_NAME, CoverSelector);
$(document).ready(function () {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/cover-selector.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/compare-summary.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/quote-status.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/compare-pane.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/quote-status.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global jQuery */


var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = "[data-quote-status]";
var PLUGIN_NAME = "quoteStatus";

var log = (0, _debug2.default)(PLUGIN_NAME);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var QuoteStatus = function () {
	function QuoteStatus(element, options) {
		_classCallCheck(this, QuoteStatus);

		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.frequencies = getJSONValue(this.options.frequencies);
		this.frequency = this.options.frequency;
		this.hospitalName = this.options.hospitalName;
		this.extrasName = this.options.extrasName;
		this.hospitalRates = getJSONValue(this.options.hospitalRates);
		this.extrasRates = getJSONValue(this.options.extrasRates);
		this.noExtras = getJSONValue(this.options.noExtras);

		this.watchAttr = {
			'data-quote-status--frequency': 'frequency',
			'data-quote-status--hospital-name': 'hospitalName',
			'data-quote-status--extras-name': 'extrasName',
			'data-quote-status--hospital-rates': 'hospitalRates',
			'data-quote-status--extras-rates': 'extrasRates',
			'data-quote-status--no-extras': 'noExtras'
		};

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.hospitalNameElement = this.element.querySelector(this.options.hospitalNameSelector);

		this.extrasNameElement = this.element.querySelector(this.options.extrasNameSelector);

		this.extrasPartElement = this.element.querySelector(this.options.extrasPartSelector);

		this.resultElement = this.element.querySelector(this.options.resultSelector);

		this.amountElement = this.element.querySelector(this.options.amountSelector);

		// todo: hide/show = $

		this.init();
		this.watch();
		log("ready", this, this.form);
	}

	_createClass(QuoteStatus, [{
		key: "init",
		value: function init() {}
	}, {
		key: "watch",
		value: function watch() {
			log("watching");
			this.attributeObserver.observe(this.element, { attributes: true });
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && this.watchAttr[mutation.attributeName];
			}.bind(this)).forEach(this.applyAttributeChanges.bind(this));
		}
	}, {
		key: "applyAttributeChanges",
		value: function applyAttributeChanges(mutation) {
			var attribute = mutation.attributeName;
			var newValue = this.element.getAttribute(attribute);
			this[this.watchAttr[attribute]] = getJSONValue(newValue);

			this.updateDisplay();
		}
	}, {
		key: "updateDisplay",
		value: function updateDisplay() {
			var _this = this;

			this.hospitalNameElement.textContent = this.hospitalName;
			this.extrasNameElement.textContent = this.extrasName;
			this.amountElement.textContent = this.calculateAmount().toFixed(2);
			this.updateHighlight(this.hospitalNameElement, this.hasHospitalValue.bind(this));
			this.updateHighlight(this.extrasNameElement, this.hasExtrasValue.bind(this));
			this.updateHidden(this.extrasPartElement, function () {
				return _this.noExtras;
			});
			this.updateHidden(this.resultElement, this.hasNoResult.bind(this));
		}
	}, {
		key: "updateHighlight",
		value: function updateHighlight(element, condition) {
			element.classList.toggle(this.options.highlightClass, condition());
		}
	}, {
		key: "updateHidden",
		value: function updateHidden(element, condition) {
			element.hidden = condition();
		}
	}, {
		key: "calculateAmount",
		value: function calculateAmount() {
			var hospitalAmount = this.getRate(this.hospitalRates);
			var extrasAmount = this.getRate(this.extrasRates);
			return hospitalAmount + extrasAmount;
		}
	}, {
		key: "getRate",
		value: function getRate(rates) {
			if (!rates || !rates.length) {
				return 0;
			}
			var frequency = this.frequency;
			// Rates may be a single value e.g. Ambulance only
			var isFixedFrequency = rates.length === 1;
			var frequencyIndex = isFixedFrequency ? 0 : this.frequencies.findIndex(function (periodName) {
				return frequency === periodName;
			});
			return rates[frequencyIndex] || 0;
		}
	}, {
		key: "hasHospitalValue",
		value: function hasHospitalValue() {
			return !!this.getRate(this.hospitalRates);
		}
	}, {
		key: "hasExtrasValue",
		value: function hasExtrasValue() {
			return !!this.getRate(this.extrasRates);
		}
	}, {
		key: "hasNoResult",
		value: function hasNoResult() {
			return this.calculateAmount() === 0;
		}
	}]);

	return QuoteStatus;
}();

QuoteStatus.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, QuoteStatus);
jQuery(document).ready(function () {
	jQuery(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/quote-form/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-quote-form]';
var PLUGIN_NAME = 'quoteForm';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("quote-form").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/quote-form/quote-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/validate-form/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-validate-form]';
var PLUGIN_NAME = 'validateForm';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("validate-form").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/validate-form/validate-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/cover-selector.module.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;
exports.exec = exec;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

var _exec = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/exec.js");

var _exec2 = _interopRequireDefault(_exec);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Health Fund Product Selector Module Bundle
 * @author Rhys Lloyd
 */

//
// Utilities
// Dependencies
var MODULE_NAME = _names.COVER_SELECTOR_MODULE;

//
// Constants

var log = (0, _debug2.default)(MODULE_NAME);

//
// Register
if (!registry.exists(MODULE_NAME)) {
	registry.register(MODULE_NAME, registry.STATE.LOADING);
}

//
// Functions
function exec() {
	(0, _exec2.default)();
}

exports.default = exec;

registry.setState(MODULE_NAME, registry.STATE.LOADED);

//
// Conditionally Self Execute
if (!registry.isRegistered(MODULE_NAME)) {
	exec();
	registry.setState(MODULE_NAME, registry.STATE.REGISTERED);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/dynamic-load.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSETS = exports.MODULE_SELECTOR = exports.MODULE_NAME = undefined;
exports.default = load;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// Constants
/**
 * Cover Selector - Dynamic Load
 * Responsible for determining if the Cover Selector needs to load, and for actually loading the files.
 */

//
// Utilities
//
// Dependencies
var MODULE_NAME = exports.MODULE_NAME = _names.COVER_SELECTOR_MODULE;
var MODULE_SELECTOR = exports.MODULE_SELECTOR = '[data-cover-selector]';
var ASSETS = exports.ASSETS = [
// '../styles/core-datepicker.module.css',
'../scripts/cover-selector.module.js'];
// theme specific cover selector css is loaded via a partial

//
// Load
function load() {
  registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/exec.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exec;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _dynamicLoad = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/dynamic-load.js");

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'cover-selector/exec'; /**
                                          * Product Selector
                                          * @author Rhys Lloyd
                                          */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

// Dependencies


/**
 * Run module
 */
function exec() {
	log('Running...');

	$(document).ready(function () {
		// Find all elements and operate
		var elements = document.querySelectorAll(_dynamicLoad.MODULE_SELECTOR);
		log('elements:', elements);

		// Backward loops are just faster
		for (var i = elements.length - 1; i >= 0; --i) {
			(0, _index2.default)(elements[i]);
		}
	});
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/cover-selector/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/quote-form/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/validate-form/index--split.js");

var _uniqueId = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/uniqueId.js");

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'cover-selector'; /**
                                     * Cover Selector
                                     */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

/**
 * Initialises the product selector.
 * @param {Element} element
 */
function init(element) {
  log('init', element);
  element.id = (0, _uniqueId2.default)('cover-selector');

  // TODO initialise components of the cover-selector

  return element;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/fn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                              jQuery plugin
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              import debug from 'debug';
                                                                                                                                                                                                                                                                              import plugin from '@core/plugins/lib';
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              const ELEMENT_SELECTOR = '[data-my-plugin]';
                                                                                                                                                                                                                                                                              const PLUGIN_NAME = 'MyPlugin';
                                                                                                                                                                                                                                                                              const MODULE_NAME = 'plugins/my-plugin';
                                                                                                                                                                                                                                                                              const log = debug(MODULE_NAME);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              class PluginKlass {
                                                                                                                                                                                                                                                                                  constructor(element, options) {
                                                                                                                                                                                                                                                                                    log('new instance', element, options);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.element = element;
                                                                                                                                                                                                                                                                                    this.options = options;
                                                                                                                                                                                                                                                                                    this.$element = $(element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    log('ready', this.$element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.init();
                                                                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              PluginKlass.DEFAULTS = {
                                                                                                                                                                                                                                                                                someCamelCasedProperty: `${PLUGIN_NAME}:something`,
                                                                                                                                                                                                                                                                              };
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              plugin(PLUGIN_NAME, PluginKlass);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              $(document).ready(() => {
                                                                                                                                                                                                                                                                                $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
                                                                                                                                                                                                                                                                              });
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Then using it in html:
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              <div class="something-else"
                                                                                                                                                                                                                                                                                   data-my-plugin
                                                                                                                                                                                                                                                                                   data-my-plugin--some-camel-cased-property="a-string:something-else"></div>
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Styelguide Core.Global.Javascript.JqueryPlugin
                                                                                                                                                                                                                                                                              */
// import $ from 'jquery';

// import * as events from './events';

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _fn = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/fn.js");

var fn = _interopRequireWildcard(_fn);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js");

var strings = _interopRequireWildcard(_strings);

var _objects = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/objects.js");

var objects = _interopRequireWildcard(_objects);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib');

function plugin(pluginName, klass) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var formattedPluginName = (0, _strings.toCamelCase)(pluginName);
  var dataName = '__' + formattedPluginName;
  var old = $.fn[formattedPluginName];
  var ZERO = 0;

  klass.$bus = {
    subscribe: function subscribe(event, fn) {
      $(this).bind(event, fn);
    },
    publish: function publish(event, data) {
      $(this).trigger(event, [data]);
    }
  };

  klass.$util = {
    fn: fn,
    objects: objects,
    strings: strings,
    selectors: selectors
  };

  klass.prototype.selectors = selectors;
  klass.prototype.strings = strings;
  klass.prototype.objects = objects;
  klass.prototype.fn = fn;
  klass.prototype.inViewport = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  $.fn[pluginName] = function PluginFactory(option) {
    return this.each(function PluginInstanceFactory() {
      var $this = $(this);
      var data = $this.data();
      var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
      var elementOptions = Object.keys(data).filter(function (key) {
        return (0, _strings.toCamelCase)(key).indexOf(formattedPluginName) >= ZERO;
      }).reduce(function (result, path) {
        var data = path && $this.data(path);
        var key = (0, _strings.toCamelCase)(path.replace(new RegExp(formattedPluginName + '-?'), ''));
        log(path, key, $this.data(path));

        if (key && data !== undefined) {
          result[key] = data;
        }
        return result;
      }, {});
      log(pluginName, { elementOptions: elementOptions });
      var instance = $this.data(dataName);
      var options = $.extend({}, klass.DEFAULTS, elementOptions, overrides);

      // store reference to instance
      if (!instance) {
        instance = new klass(this, options);
        instance.$utils = klass.$util;
        $this.data(dataName, instance);
        $this.addClass('u-' + pluginName);
      }

      // execute instance method
      if (typeof option === 'string') {
        instance[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    $[formattedPluginName] = function (options) {
      return $({})[formattedPluginName](options);
    };
  }

  // - No conflict
  // $.fn[formattedPluginName].noConflict = function noConflict () {
  //   $.fn[formattedPluginName] = old;
  // };
}

function jquery(name) {
  return function decorate(target) {
    plugin(name, target);
  };
}

function defaults(options) {
  return function decorate(target) {
    target.DEFAULTS = options;
  };
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.objectPath = objectPath;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
  var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return (0, _strings.toCamelCase)(name);
  };

  var output = {};
  var attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log('converting element attributes to object', attrs);

  return attrs.reduce(function (result, attribute) {
    if (filterFn(attribute)) {
      var name = transformFn(attribute.name);
      var value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);
}

/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

function objectPath(obj, path, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { delimiter: '.' };

  var props = path.split(options.delimiter);
  var final = props.pop();
  var part = void 0;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      } else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? obj[final] = val : obj[final];
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTOR_PATTERNS = undefined;
exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib/selectors'); // import $ from 'jquery';
function selectorPattern() {
  for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
    directives[_key] = arguments[_key];
  }

  return new RegExp('\\((' + directives.join('|') + ')(.*)\\)\\s?(.*)');
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {

  // .find
  "children": selectorPattern('children'),

  // .closest
  "parent": selectorPattern('parent'),
  "from": selectorPattern('from'),
  "parents": selectorPattern('parents'),
  "siblings": selectorPattern('siblings'),
  "here": selectorPattern('here'),
  "self": selectorPattern('self')
};

function selectTarget(selector, $element) {
  var $target = void 0;

  var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
  var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
  var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
  var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
  var isGenerational = selector.match(SELECTOR_PATTERNS.here);
  var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
  var isSelfish = selector.match(SELECTOR_PATTERNS.self);

  // special retargeting root
  if (isRetargeted) {
    log('isRetargeted', isRetargeted[2], isRetargeted[3]);
    var $newElement = selectTarget(isRetargeted[2], $element);
    var newSelector = '(children) ' + isRetargeted[3];
    log('isRetargeted.newElement', $newElement);
    log('isRetargeted.newSelector', newSelector);
    $target = selectTarget(newSelector, $newElement);
    log('isRetargeted.target', $target);
  }

  // target is all ancestors
  else if (isAllAncestoral) {
      log('isAllAncestoral', isAllAncestoral);
      $target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
    }
    // target is closest ancestor
    else if (isClosestAncestoral) {
        log('isClosestAncestoral', isClosestAncestoral);
        $target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
      }
      // target is somewhere under current parent
      else if (isGenerational) {
          log('isGenerational', isGenerational);
          $target = $element.parent().find(isGenerational[isGenerational.length - 1]);
        }
        // target is only under self
        else if (isAllDescendants) {
            log('isAllDescendants', isAllDescendants);
            $target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
          }
          // target is somewhere in siblings only
          else if (isSiblings) {
              log('isSiblings', isSiblings);
              $target = $element.siblings(isSiblings[isSiblings.length - 1]);
            }
            // target is source
            else if (!selector || isSelfish) {
                log('isSelfish', isSelfish);
                var selector = isSelfish[isSelfish.length - 1] || '*';
                $target = $element.filter(selector);
              }
              // target could be anywhere
              else {
                  log('global', selector);
                  $target = $(selector);
                }
  return $target;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // import $ from 'jquery';


exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;
exports.booleanify = booleanify;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

function toCamelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  var hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
};

function tmpl(str, context) {
  var result = str;

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });
  }

  return result;
}

function $tmpl(element, context) {
  var $target = $(element);
  var templateString = $target.attr('data-text-template');
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', { template: template, self: self, parent: parent, invert: invert });

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {

      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }

      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
      log('mustache.output.' + depth, { output: output });
    });
  }
  log('mustache.output', { output: output });
  return output;
}

function booleanify(value) {
  var lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/dynamic-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dynamicLoader;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var _toast = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/pyrsmk-toast/toast.js");

var _toast2 = _interopRequireDefault(_toast);

var _isString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isString.js");

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'dynamic-loader'; /**
                                     * Registry Dynamic Loader
                                     * Common dynamic loading template.
                                     * @author Rhys Lloyd
                                     */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);
//
// Dependencies


var staticPath = undefined;
var staticPathElement = document.querySelector('meta[name="site.paths.static"]');
if (staticPathElement) {
	staticPath = staticPathElement.content;
}

//
// Constants
var STATIC_PATH = staticPath;
var MANIFEST_FILE = STATIC_PATH + 'manifest.json';
var MANIFEST_FILE_DATA = undefined;
//
// Load

/**
 * Loads a module based on the existence of a selector.
 * @param {String} module - name of module to load (for registration)
 * @param {String} selector - selector to test for with document.querySelector
 * @param {Array} loadArray - array of assets to load (pass to toast.js)
 */
function dynamicLoader(module, selector, loadArray) {
	if ((0, _index.exists)(module)) {
		log('Module "' + module + '" already loaded. Exiting.');
		return;
	}

	log('Looking for selector "' + selector + '"');
	var hasElements = !!document.querySelector(selector);

	if (!hasElements) {
		log('...no elements. Exiting.');
		(0, _index.register)(module, _index.STATE.NOT_REQUIRED);
		return;
	}

	readTextFile(MANIFEST_FILE, getManifestFileName, loadArray, module);
}

function getManifestFileName(text, loadArray, module) {
	var MANIFEST_FILE_DATA = JSON.parse(text);
	var resolvedLoadArray = loadArray.map(function (item) {
		if (!(0, _isString2.default)(item)) {
			return item;
		}
		var newItem = item.replace('../', STATIC_PATH);
		if (MANIFEST_FILE_DATA[newItem]) {
			return MANIFEST_FILE_DATA[newItem];
		}
		return newItem;
	});

	log('Loading ' + module + ' with assetArray', resolvedLoadArray);
	_toast2.default.apply(null, resolvedLoadArray);

	(0, _index.register)(module, _index.STATE.LOADING);
}

function readTextFile(file, callback, loadArray, module) {
	var rawFile = new XMLHttpRequest();
	rawFile.overrideMimeType("application/json");
	rawFile.open("GET", file, true);
	rawFile.onreadystatechange = function () {
		if (rawFile.readyState === 4 && rawFile.status == "200") {
			return callback(rawFile.responseText, loadArray, module);
		}
	};
	rawFile.send(null);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exports.STATE = undefined;

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

Object.keys(_names).forEach(function (key) {
	if (key === "default" || key === "__esModule") return;
	Object.defineProperty(exports, key, {
		enumerable: true,
		get: function get() {
			return _names[key];
		}
	});
});
exports.register = register;
exports.exists = exists;
exports.isRegistered = isRegistered;
exports.getState = getState;
exports.setState = setState;
exports.validState = validState;
exports.dynamicLoader = dynamicLoader;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _state = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/state.js");

var _state2 = _interopRequireDefault(_state);

var _dynamicLoader = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/dynamic-loader.js");

var dl = _interopRequireWildcard(_dynamicLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'registry'; /**
                               * Extremely Basic Module Registry
                               * Designed to prevent asynchronously modules from being loaded and run more than once.
                               * @author Rhys Lloyd
                               */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

//
// Dependencies


//
// Constants
var REGISTRY = {};
var STATE = exports.STATE = _state2.default;

//
// Functions

/**
 * Registers a module.
 * @param module
 * @param state
 * @returns {*}
 */
function register(module, state) {
	if (exists(module)) {
		log('register(): Attempting to re-register an existing module: "' + module + '"', 'Existing:', REGISTRY[module]);
		return;
	}

	if (!state || !validState(state)) {
		state = STATE.INIT;
	}

	REGISTRY[module] = {
		state: state
	};

	log('register(): Registering module "' + module + '" with state "' + state.name + '"');
	return REGISTRY[module];
}

/**
 * Returns the object in the registry
 * @param module
 * @returns {*}
 */
function exists(module) {
	return !!REGISTRY[module];
}

/**
 * Checks if a module is marked as registered.
 * @param module
 * @returns {*|boolean}
 */
function isRegistered(module) {
	return exists(module) && getState(module) == STATE.REGISTERED;
}

/**
 * Get the state of a registered module.
 * @param module
 * @returns {*}
 */
function getState(module) {
	if (!exists(module)) {
		log('getState(): module "' + module + '" doesn\'t exist');
		return;
	}

	var state = REGISTRY[module].state;
	log('getState(): Getting state "' + state.name + '" for module "' + module + '"');
	return state;
}

/**
 * Get the state of a registered module.
 * @param module
 * @param state
 * @returns {*}
 */
function setState(module, state) {
	if (!exists(module)) {
		log('setState(): module "' + module + '" doesn\'t exist');
		return;
	}

	if (!validState(state)) {
		log('setState(): state "' + state + '" doesn\'t exist (attempt on module "' + module + '")');
	}

	log('setState(): Setting state "' + state.name + '" for module "' + module + '"');
	REGISTRY[module].state = state;
}

/**
 * Verifies that a state is valid
 * @param state
 * @returns {boolean}
 */
function validState(state) {
	return state instanceof _state2.default;
}

exports.default = register;
function dynamicLoader(module, selector, loadArray) {
	return dl.default(module, selector, loadArray);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Registry Module Names
 */

// Core
var CORE_MODULE = exports.CORE_MODULE = 'core';
var DATEPICKER_MODULE = exports.DATEPICKER_MODULE = 'datepicker';
var PS_QUOTE_FORM_MODULE = exports.PS_QUOTE_FORM_MODULE = 'ps-quote-form';
var LOCATOR_MODULE = exports.LOCATOR_MODULE = 'locator';
var COVER_SELECTOR_MODULE = exports.COVER_SELECTOR_MODULE = "cover-selector";

// Dev
var DEV_MODULE = exports.DEV_MODULE = 'dev';
var DEV_THEME_SWITCHER = exports.DEV_THEME_SWITCHER = DEV_MODULE + '-theme-switcher';

// Health Fund
var HF_APP_MODULE = exports.HF_APP_MODULE = 'hf-app';
var HF_PRODUCT_SELECTOR_MODULE = exports.HF_PRODUCT_SELECTOR_MODULE = 'hf-product-selector';
var HF_PRODUCT_DETAIL_CARD_MODULE = exports.HF_PRODUCT_DETAIL_CARD_MODULE = 'hf-product-detail-card';

// NT Health Fund
var NT_HF_APP_MODULE = exports.NT_HF_APP_MODULE = 'nt-cu-app';

// SeeU
var SEEU_APP_MODULE = exports.SEEU_APP_MODULE = 'seeu-app';
// export const SEEU_PRODUCT_COMPARE_MODULE = 'cu-product-compare';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/state.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enumify = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/enumify/enumify.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Registry States
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * States for Registry
 * See docs: https://github.com/rauschma/enumify
 */
var State = function (_Enum) {
  _inherits(State, _Enum);

  function State() {
    _classCallCheck(this, State);

    return _possibleConstructorReturn(this, (State.__proto__ || Object.getPrototypeOf(State)).apply(this, arguments));
  }

  return State;
}(_enumify.Enum);

State.initEnum(['INIT', 'FAIL', 'LOADING', 'LOADED', 'REGISTERED', 'NOT_REQUIRED', 'CANCELLED']);

exports.default = State;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/enumify/enumify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyProperties = copyProperties;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var INITIALIZED = Symbol();

/**
 * This is an abstract class that is not intended to be
 * used directly. Extend it to turn your class into an enum
 * (initialization is performed via `MyClass.initEnum()`).
 */

var Enum = exports.Enum = function () {
    /**
     * `initEnum()` closes the class. Then calling this constructor
     * throws an exception.
     * 
     * If your subclass has a constructor then you can control
     * what properties are added to `this` via the argument you
     * pass to `super()`. No arguments are fine, too.
     */

    function Enum() {
        var instanceProperties = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

        _classCallCheck(this, Enum);

        // new.target would be better than this.constructor,
        // but isn’t supported by Babel
        if ({}.hasOwnProperty.call(this.constructor, INITIALIZED)) {
            throw new Error('Enum classes can’t be instantiated');
        }
        if ((typeof instanceProperties === 'undefined' ? 'undefined' : _typeof(instanceProperties)) === 'object' && instanceProperties !== null) {
            copyProperties(this, instanceProperties);
        }
    }
    /**
     * Set up the enum, close the class.
     * 
     * @param arg Either an object whose properties provide the names
     * and values (which must be mutable objects) of the enum constants.
     * Or an Array whose elements are used as the names of the enum constants
     * The values are create by instantiating the current class.
     */

    _createClass(Enum, [{
        key: 'toString',

        /**
         * Default `toString()` method for enum constant.
         */
        value: function toString() {
            return this.constructor.name + '.' + this.name;
        }
    }], [{
        key: 'initEnum',
        value: function initEnum(arg) {
            Object.defineProperty(this, 'enumValues', {
                value: [],
                configurable: false,
                writable: false,
                enumerable: true
            });
            if (Array.isArray(arg)) {
                this._enumValuesFromArray(arg);
            } else {
                this._enumValuesFromObject(arg);
            }
            Object.freeze(this.enumValues);
            this[INITIALIZED] = true;
            return this;
        }
    }, {
        key: '_enumValuesFromArray',
        value: function _enumValuesFromArray(arr) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    this._pushEnumValue(new this(), key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: '_enumValuesFromObject',
        value: function _enumValuesFromObject(obj) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(obj)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    var value = new this(obj[key]);
                    this._pushEnumValue(value, key);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: '_pushEnumValue',
        value: function _pushEnumValue(enumValue, name) {
            enumValue.name = name;
            enumValue.ordinal = this.enumValues.length;
            Object.defineProperty(this, name, {
                value: enumValue,
                configurable: false,
                writable: false,
                enumerable: true
            });
            this.enumValues.push(enumValue);
        }

        /**
         * Given the name of an enum constant, return its value.
         */

    }, {
        key: 'enumValueOf',
        value: function enumValueOf(name) {
            return this.enumValues.find(function (x) {
                return x.name === name;
            });
        }

        /**
         * Make enum classes iterable
         */

    }, {
        key: Symbol.iterator,
        value: function value() {
            return this.enumValues[Symbol.iterator]();
        }
    }]);

    return Enum;
}();

function copyProperties(target, source) {
    // Ideally, we’d use Reflect.ownKeys() here,
    // but I don’t want to depend on a polyfill
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = Object.getOwnPropertyNames(source)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            var desc = Object.getOwnPropertyDescriptor(source, key);
            Object.defineProperty(target, key, desc);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return target;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/pyrsmk-toast/toast.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
	} else {
		root.toast = factory();
	}
})(undefined, function () {
	/*! toast 2.1.0 (https://github.com/pyrsmk/toast) */

	var handled_resources = {};

	function toast() {
		var head = document.getElementsByTagName('head')[0],


		// Load as much resources as we can
		loadResources = function loadResources(resources) {
			// Waiting for DOM readiness then load resources
			if (!head) {
				setTimeout(function () {
					loadResources(resources);
				}, 50);
			}
			// Load resources
			else if (resources.length) {
					var i = -1,
					    resource,
					    callback;
					while (resource = resources[++i]) {
						// Resource
						if (typeof resource == 'string') {
							loadResource(resource);
						}
						// Callback
						else if (typeof resource == 'function') {
								callback = resource;
								break;
							}
					}
					watchResources(callback, Array.prototype.slice.call(resources, i + 1));
				}
		},


		// Load one resource
		loadResource = function loadResource(resource) {
			// Extract resource type
			var implicit_type = /\.(\w+)$/.exec(resource),
			    explicit_type = /^\[(\w+)\](.+)/.exec(resource),
			    type,
			    node;
			if (explicit_type !== null) {
				type = explicit_type[1];
				resource = explicit_type[2];
			} else if (implicit_type !== null) {
				type = implicit_type[1];
			} else {
				return;
			}
			// Verify if the resource is not already handled
			if (resource in handled_resources) {
				return;
			}
			// Mark the resource as handled (but not loaded yet)
			handled_resources[resource] = false;
			// Load resource
			switch (type) {
				case 'js':
					// Create SCRIPT element
					node = document.createElement('script');
					node.src = resource;
					node.type = 'text/javascript';
					head.appendChild(node);
					// Watch loading state
					var version = navigator.appVersion.match(/MSIE (\d)/);
					if (version !== null && parseInt(version[1], 10) < 9) {
						// IE<9
						node.onreadystatechange = function () {
							if (/ded|co/.test(this.readyState)) {
								handled_resources[resource] = true;
							}
						};
					} else {
						// Other browsers
						node.onload = function () {
							handled_resources[resource] = true;
						};
					}
					break;
				case 'css':
					// Create LINK element
					node = document.createElement('link');
					node.rel = 'styleSheet';
					node.href = resource;
					head.appendChild(node);
					// Watch loading state
					watchStylesheet(node, resource);
					break;
				default:
					delete handled_resources[resource];
					return;
			}
		},


		// Watch if all resources have been loaded
		watchResources = function watchResources(callback, resourcesToLoad) {
			for (var resource in handled_resources) {
				if (!handled_resources[resource]) {
					setTimeout(function () {
						watchResources(callback, resourcesToLoad);
					}, 50);
					return;
				}
			}
			if (typeof callback == 'function') {
				callback();
			}
			loadResources(resourcesToLoad);
		},


		// Watch if a CSS resource has been loaded
		watchStylesheet = function watchStylesheet(node, resource) {
			if (node.sheet || node.styleSheet) {
				handled_resources[resource] = true;
			} else {
				setTimeout(function () {
					watchStylesheet(node, resource);
				}, 50);
			}
		};

		// Load resources
		loadResources(arguments);
	}
	return toast;
});

/***/ }),

/***/ "external \"jQuery\"":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "multi /tool/project/client/src/core/modules/cover-selector/cover-selector.module.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/cover-selector.module.js");


/***/ })

},["multi /tool/project/client/src/core/modules/cover-selector/cover-selector.module.js"]);


// WEBPACK FOOTER //
// scripts/cover-selector.module--c7657f2915eb074d0a33.js